export default "__VITE_ASSET__1326cdc3__"